import React, { useState } from 'react'
import { Tab } from '@headlessui/react'
import TenantForm from './TenantForm'
import ManageTenants from './ManageTenants'
import { clearCahce } from '../../services/Token'
import { useNavigate } from 'react-router-dom'
import EiLogo from "../../Icons/EiLogo.svg"
import EmployeeData from './EmployeeData'
import OrganizationChart from '../OrganizationChart'
import AnnouncementBanner from '../Announcement'
import { useDispatch, useSelector } from 'react-redux'
import { setStep } from '../../store/reducers/authSlice'
import { resetApp } from '../../store/reducers/rootReducer'

const TenatDashboard = () => {
    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
      }
    const navigate = useNavigate();
  const { isAnnouncementOpen } = useSelector((state) => state.notification);
  const dispatch = useDispatch();

  const navItems = [
    {
      label: "Onboard Tenant",
      sub: "Create a new organization",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg>
      ),
    },
    {
      label: "Manage Tenants",
      sub: "View & edit organizations",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21V8l9-5 9 5v13" /><path d="M9 21V12h6v9" /></svg>
      ),
    },
    {
      label: "Employees",
      sub: "Search across tenants",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="8" r="4" /><path d="M3 21v-1a6 6 0 0 1 12 0v1" /><circle cx="17" cy="10" r="3" /><path d="M21 21v-1a4 4 0 0 0-4-4" /></svg>
      ),
    },
    {
      label: "Organization Chart",
      sub: "View tenant hierarchy",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="8" y="1" width="8" height="5" rx="1.5"/><rect x="1" y="18" width="6" height="5" rx="1.5"/><rect x="9" y="18" width="6" height="5" rx="1.5"/><rect x="17" y="18" width="6" height="5" rx="1.5"/><line x1="12" y1="6" x2="12" y2="11"/><line x1="4" y1="11" x2="20" y2="11"/><line x1="4" y1="11" x2="4" y2="18"/><line x1="12" y1="11" x2="12" y2="18"/><line x1="20" y1="11" x2="20" y2="18"/></svg>
      ),
    },
  ];

  return (
    <>
      <AnnouncementBanner />
      <div
        className={`${
          isAnnouncementOpen && "mt-14"
        } w-full min-h-screen bg-blue-secondery-2 text-gray-primary flex`}
      >
        <Tab.Group vertical>
          {/* ── Sidebar ── */}
          <aside className={`w-72 bg-white border-r border-blue-secondery flex flex-col fixed ${isAnnouncementOpen ? "top-14" : "top-0"} left-0 h-screen overflow-y-auto z-30`}>
            {/* Brand */}
            <div className="px-6 pt-7 pb-6 border-b border-blue-secondery-1">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-2xl bg-blue-primary flex items-center justify-center shadow-md shadow-blue-secondery">
                  <img className="w-7 h-7" src={EiLogo} alt="ICON" />
                </div>
                <div className="flex flex-col leading-tight cursor-default">
                  <h2 className="text-lg font-sans tracking-tight text-slate-800">
                    <span className="font-bold">work</span>
                    <span className="font-bold">force</span>
                    <span className="text-xl font-extrabold text-blue-primary ml-0.5">HR</span>
                  </h2>
                  <span className="text-[10px] uppercase tracking-[0.2em] font-semibold text-gray-primary mt-0.5">Super Admin</span>
                </div>
              </div>
            </div>

            {/* Nav */}
            <Tab.List className="flex flex-col gap-1.5 px-4 pt-5 pb-2 flex-1">
              <p className="text-[10px] uppercase tracking-[0.18em] font-bold text-gray-primary px-2 mb-2">Workspace</p>
              {navItems.map((item, idx) => (
                <Tab
                  key={idx}
                  className={({ selected }) =>
                    classNames(
                      "group w-full text-left rounded-xl px-3 py-3 transition-all duration-150 flex items-start gap-3 focus:outline-none",
                      selected
                        ? "bg-blue-primary text-white shadow-md shadow-blue-secondery"
                        : "text-slate-700 hover:bg-blue-secondery-2"
                    )
                  }
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={classNames(
                          "shrink-0 w-9 h-9 rounded-lg flex items-center justify-center transition-colors",
                          selected ? "bg-white/20 text-white" : "bg-blue-secondery-2 text-blue-primary group-hover:bg-white"
                        )}
                      >
                        {item.icon}
                      </span>
                      <span className="flex flex-col leading-tight pt-0.5">
                        <span className={classNames("text-sm font-semibold", selected ? "text-white" : "text-slate-800")}>{item.label}</span>
                        <span className={classNames("text-[11px] mt-0.5", selected ? "text-white/80" : "text-gray-primary")}>{item.sub}</span>
                      </span>
                    </>
                  )}
                </Tab>
              ))}
            </Tab.List>

            {/* Logout */}
            <div className="px-4 pb-5 pt-3 border-t border-blue-secondery-1">
              <button
                className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-white border border-blue-secondery text-slate-700 text-sm font-semibold hover:bg-blue-secondery-2 hover:border-blue-primary hover:text-blue-primary transition-all duration-200 cursor-pointer"
                onClick={() => {
                  clearCahce();
                  dispatch(resetApp());
                  navigate("/login");
                  dispatch(setStep("login"));
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
                Sign out
              </button>
            </div>
          </aside>

          {/* ── Main content ── */}
          <main className="flex-1 min-w-0 min-h-screen flex flex-col overflow-x-hidden ml-72">
            {/* Top bar */}
            <header className="h-16 border-b border-blue-secondery-1 bg-white/70 backdrop-blur-sm sticky top-0 z-20 flex items-center justify-between px-8">
              <div className="flex flex-col leading-tight">
                <span className="text-[11px] uppercase tracking-[0.18em] font-semibold text-gray-primary">Super Admin Console</span>
                <span className="text-base font-bold text-slate-800">Tenant & Employee Management</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="hidden md:flex flex-col items-end leading-tight">
                  <span className="text-sm font-semibold text-slate-800">Super Admin</span>
                  <span className="text-[11px] text-gray-primary">Platform Owner</span>
                </div>
                <div className="w-10 h-10 rounded-full bg-blue-primary text-white flex items-center justify-center font-bold text-sm shadow-md shadow-blue-secondery ring-2 ring-white">
                  SA
                </div>
              </div>
            </header>

            <Tab.Panels className="flex-1">
              <Tab.Panel className="focus:outline-none">
                {<TenantForm />}
              </Tab.Panel>
              <Tab.Panel className="focus:outline-none">
                {<ManageTenants />}
              </Tab.Panel>
              <Tab.Panel className="focus:outline-none">
                {<EmployeeData />}
              </Tab.Panel>
              <Tab.Panel className="focus:outline-none">
                <OrganizationChart />
              </Tab.Panel>
            </Tab.Panels>
          </main>
        </Tab.Group>
      </div>
    </>
  );
}

export default TenatDashboard
